import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="overflow-hidden rounded-xl bg-primary-500 px-6 py-14 text-center md:px-12">
        <h2 className="mx-auto max-w-3xl font-heading text-2xl font-semibold text-background-50 md:text-4xl">
          {t('home.ctaTitle')}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-primary-100 md:text-base">
          {t('home.ctaCopy')}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-background-50 px-7 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 cursor-pointer whitespace-nowrap sm:w-auto"
          >
            {t('home.ctaPrimary')}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <Link
            to="/article/allchinabuy-spreadsheet-guide"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-600 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700 cursor-pointer whitespace-nowrap sm:w-auto"
          >
            {t('home.ctaSecondary')}
            <i className="ri-book-open-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}